const autocompleteFormEquip = {
  local: 'Lugar',
  equipment: 'Equipo',
  area: 'Departamento',
  company: 'Terceras empresas',
  equipInfo: 'Detalles del equipo',
  equipmentAttachments: 'Adjuntos para este equipo',
  equipmentModelAttachments: 'Adjuntos de tipo de equipo',
  noAttachments: 'No hay adjuntos disponibles',
};

export default autocompleteFormEquip;
